import { Injectable } from '@angular/core';

@Injectable()
export class PreLoadService {

    constructor( ) {


    }

    load() {


    }

}